import { activityHistoryCollectionsSlice } from "../../slice";

export const { addActivityHistoryItems } = activityHistoryCollectionsSlice.actions;
